export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.m2hse.co.uk/api";
export const STRIPE_KEY =
  "pk_live_51Ocb2bS1SfXYV3NpMnFJJrvXO3bg7lmkkXVylzAb9BFLwljAyNdrmrqCoi7xptUxc1sHRMFAlti9FIm5XC1iE6lu00JA1YIrOT";
